// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { createWorkshopNotes } from '../../../apis/workshop';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { createWorkshopNoteActions } = actionCreatorsList;

const outputActions = {
  success: createWorkshopNoteActions.success,
  failure: createWorkshopNoteActions.failure
};

type RequestActionTypes = ActionType<
  typeof createWorkshopNoteActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getWorkshopNotesDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(createWorkshopNoteActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, vodId, time, message } = action.payload;

      // send api promise
      return createWorkshopNotes(id, vodId, time, message)
        .then(response => {
          const notes = response.data.message.notes;
          // handle success case here
          const parsedNotes = parseCamelCase(notes).map((note:any) => ({
            ...note,
            message: note.note,
            note: undefined
          }));
          return createWorkshopNoteActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return createWorkshopNoteActions.failure({ error });
        });
    })
  );
};

export { getWorkshopNotesDataEpic as default};
